/**
 * 个人中心
 */
export default [
  {
    path: '/mine',
    component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/Index.vue'),
    meta: { requiresAuth: true, title: '我的', icon: 'el-icon-s-ticket', role: true },
    children:
      [
        {
          path: 'shop', //商户端
          component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/Index.vue'),
          meta: { title: '我的', role: true },
          children: [
            {
              path: '',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/MainMine.vue'),
              meta: { title: '我的', role: true },
            },
            {
              path: 'accountmanage',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/Shop.vue'),
              meta: { title: '账户管理', role: true },
            },

            {
              path: 'statisticlist',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/StatisticList.vue'),
              meta: { title: '数据统计', role: true },
            },
            {
              path: 'account',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/AccountShop.vue'),
              meta: { title: '账户资料', role: true },
            },
            {
              path: 'modify',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/ModifyShop.vue'),
              meta: { title: '修改密码', role: true },
            },
          ]
        },
        {
          path: 'market', //商管端
          component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/Index.vue'),
          meta: { title: '我的', role: true },
          children: [
            {
              path: '',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/MainMark.vue'),
              meta: { title: '我的', role: true },
            },
            {
              path: 'accountmanage',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/Market.vue'),
              meta: { title: '账户管理', role: true },
            },
            {
              path: 'account',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/AccountMarket.vue'),
              meta: { title: '账户资料', role: true },
            },
            {
              path: 'modify',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/ModifyMarket.vue'),
              meta: { title: '修改密码', role: true },
            },
          ]
        },
        {
          path: 'estate', //维修工端
          component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/Index.vue'),
          meta: { title: '我的', role: true },
          children: [
            {
              path: '',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/estate/Mark.vue'),
              meta: { title: '我的', role: true },
            },
            {
              path: 'accountmanage',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/estate/Market.vue'),
              meta: { title: '账户管理', role: true },
            },
            {
              path: 'account',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/estate/AccountMarket.vue'),
              meta: { title: '账户资料', role: true },
            },
            {
              path: 'modify',
              component: () => import(/* webpackChunkName: "Mine" */ '@/views/mine/estate/ModifyMarket.vue'),
              meta: { title: '修改密码', role: true },
            },
          ]
        },
      ],
  },
];
